import React from 'react';
import { useDropzone } from 'react-dropzone';

const XLSX_ACCEPT = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
};

export const PDF_ACCEPT = { 'application/pdf': ['.pdf'] };

export default function UploadZone({ file, onFileAccepted, accept = XLSX_ACCEPT, hint = 'Drag & drop a Greenbook .xlsx file here' }) {
  const extensions = Object.values(accept).flat().join(', ');
  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    accept,
    multiple: false,
    onDrop: (accepted) => {
      if (accepted.length > 0) onFileAccepted(accepted[0]);
    },
  });

  let borderColor = 'border-gray-300';
  let bgColor = 'bg-gray-50';
  let textColor = 'text-gray-500';

  if (isDragReject) {
    borderColor = 'border-red-400';
    bgColor = 'bg-red-50';
    textColor = 'text-red-500';
  } else if (isDragActive) {
    borderColor = 'border-blue-400';
    bgColor = 'bg-blue-50';
    textColor = 'text-blue-600';
  } else if (file) {
    borderColor = 'border-green-400';
    bgColor = 'bg-green-50';
    textColor = 'text-green-700';
  }

  return (
    <div
      {...getRootProps()}
      className={`border-2 border-dashed rounded-xl px-6 py-10 text-center cursor-pointer transition-colors ${borderColor} ${bgColor}`}
    >
      <input {...getInputProps()} />

      {/* Icon */}
      <div className="flex justify-center mb-3">
        {file ? (
          <svg className="w-10 h-10 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ) : (
          <svg className="w-10 h-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
        )}
      </div>

      {/* Message */}
      <p className={`text-sm font-medium ${textColor}`}>
        {isDragReject
          ? `Only ${extensions} files are accepted`
          : isDragActive
          ? 'Drop the file here'
          : file
          ? file.name
          : hint}
      </p>

      {!file && !isDragActive && (
        <p className="text-xs text-gray-400 mt-1">or click to browse</p>
      )}

      {file && (
        <p className="text-xs text-gray-400 mt-1">
          {(file.size / 1024).toFixed(0)} KB — click to choose a different file
        </p>
      )}
    </div>
  );
}
